module.exports = __webpack_public_path__ + "img/rch.1afcb95f.jpg";